import CardResource from '@ece-models/card-resource';
import DevelopmentalObjective from '@ece-models/developmental-objective';

export default class PlannerProductCard {
  cardId: string;
  plannerGroupId: string;
  themeId: string;
  groupName: string;
  isCustomCard: boolean;
  skillArea: string;
  cardTitle: string;
  cardFrontImage: string;
  cardDescription: string;
  notes: string;
  borderColor: string;
  groupIcon: string;
  developmentalObjectives: DevelopmentalObjective[] = [];
  resources: CardResource[] = [];

  constructor(data?: any) {
    if (data) {
      this.cardId = data.cardId;
      this.plannerGroupId = data.plannerGroupId;
      this.themeId = data.themeId;
      this.groupName = data.groupName;
      this.isCustomCard = data.isCustomCard;
      this.skillArea = data.skillArea;
      this.cardTitle = data.cardTitle;
      this.cardFrontImage = data.cardFrontImage;
      this.cardDescription = data.cardDescription;
      this.notes = data.notes;
      this.borderColor = data.borderColor;
      this.groupIcon = data.groupIcon;
      if (data.developmentalObjectives) {
        this.developmentalObjectives = data.developmentalObjectives;
      }
      if (data.resources) {
        this.resources = data.response;
      }
    }
  }
}


